import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, Button, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import AuthPageShell from '@components/layout/AuthPageShell';
import AuthFormCard, { authPrimaryCtaSx } from '@components/layout/AuthFormCard';

const ClaimPlayerEmailPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setError('');
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setSaving(true);
    try {
      const res = await fetch('/api/auth/handoff/confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const json = await res.json();
      if (!res.ok || !json.success) throw new Error(json.message || 'Handoff failed');
      toast.success(json.message || 'Player ID linked to your email.');
      navigate('/login');
    } catch (err: any) {
      setError(err.message || 'Handoff failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <AuthPageShell>
      <AuthFormCard
        roleLabel="Player"
        title="Claim your Player ID"
        subtitle="Set your own password. After this, your parent no longer controls the account. Scores and certificates stay on the same Player ID."
        chrome
        backTo="/login"
      >
        {!token && <Alert severity="error">Missing handoff token.</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          label="New password *"
          type="password"
          fullWidth
          sx={{ mb: 2 }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          label="Confirm password *"
          type="password"
          fullWidth
          sx={{ mb: 2 }}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        <Button
          fullWidth
          variant="contained"
          disabled={!token || saving}
          onClick={submit}
          sx={{ ...authPrimaryCtaSx, mb: 1 }}
        >
          Claim Player ID
        </Button>
      </AuthFormCard>
    </AuthPageShell>
  );
};

export default ClaimPlayerEmailPage;
